import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "../../lib/hooks";

/** 링 + 점으로 구성된 커스텀 커서. 포인터 기기(마우스)에서만 붙는다. */
export default function Cursor() {
	const hasFinePointer = useMediaQuery("(pointer: fine) and (hover: hover)");
	const ring = useRef(null);
	const dot = useRef(null);
	const [hot, setHot] = useState(false);

	useEffect(() => {
		if (!hasFinePointer) return undefined;

		// JS가 살아 있을 때만 기본 커서를 감춘다 — 스크립트가 죽으면 커서가 사라지는 사고를 막는다
		document.documentElement.classList.add("has-custom-cursor");

		const target = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
		const current = { ...target };
		let frame;

		const onMove = (e) => {
			target.x = e.clientX;
			target.y = e.clientY;
			if (dot.current) dot.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate(-50%, -50%)`;

			const interactive = e.target.closest?.("a, button, [data-cursor]");
			setHot(Boolean(interactive));
		};

		const tick = () => {
			current.x += (target.x - current.x) * 0.16;
			current.y += (target.y - current.y) * 0.16;
			if (ring.current) ring.current.style.transform = `translate3d(${current.x}px, ${current.y}px, 0) translate(-50%, -50%)`;
			frame = requestAnimationFrame(tick);
		};

		window.addEventListener("pointermove", onMove, { passive: true });
		frame = requestAnimationFrame(tick);

		return () => {
			window.removeEventListener("pointermove", onMove);
			cancelAnimationFrame(frame);
			document.documentElement.classList.remove("has-custom-cursor");
		};
	}, [hasFinePointer]);

	if (!hasFinePointer) return null;

	return (
		<>
			<div
				ref={ring}
				aria-hidden
				className={`pointer-events-none fixed left-0 top-0 z-[100] rounded-full border transition-[width,height,border-color,background-color] duration-300 ease-out ${
					hot ? "h-14 w-14 border-accent bg-accent/10" : "h-8 w-8 border-content-muted/60"
				}`}
			/>
			<div
				ref={dot}
				aria-hidden
				className={`pointer-events-none fixed left-0 top-0 z-[100] h-1.5 w-1.5 rounded-full transition-colors duration-200 ${
					hot ? "bg-accent" : "bg-content-primary"
				}`}
			/>
		</>
	);
}
